import { environment } from "src/environments/environment";

export const logger = {
    log: (...args: any[]) => {
        if (!environment.production) {
            console.log(args);
        }
    }
}
